import { Box } from "@chakra-ui/react"
import React from "react"

interface ChevronThinIconProps {
  color?: string
  w?: number
  h?: number
  strokeWidth?: number
}

const ChevronThinIcon: React.FC<ChevronThinIconProps> = ({ color, w, h, strokeWidth }) => {
  return (
    <Box display="inline-block">
      <svg width={w ?? "14"} height={h ?? 10} viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Property 1=IconChevron-thin+s">
          <path id="Vector 4" d="M3 3.6001L9 9.6001L15 3.6001" stroke={color ?? "white"} strokeWidth={strokeWidth ?? 1} />
        </g>
      </svg>
    </Box>
  )
}

export default ChevronThinIcon
